import { Lock, SquareCode } from 'lucide-react'

import { Button } from '@/components/ui/button'

export const HIDDEN_BLOCK_MESSAGE =
  'Careforce manages this snippet. Its text is not shown here. Calls with this script use it as normal.'

export function SnippetBlockHidden() {
  return (
    <>
      <span className="flex items-center gap-1 text-sm font-medium text-black-alpha-9">
        <Lock aria-hidden="true" className="size-4 shrink-0" />
        Managed by Careforce
      </span>
      <p className="mt-2 text-sm text-muted-foreground">
        {HIDDEN_BLOCK_MESSAGE}
      </p>
    </>
  )
}

type SnippetBlockUnresolvedProps = {
  id: string
  failedToLoad: boolean
  interactive: boolean
  onRemove: () => void
  onRetry?: () => void
}

export function SnippetBlockUnresolved({
  id,
  failedToLoad,
  interactive,
  onRemove,
  onRetry,
}: SnippetBlockUnresolvedProps) {
  const label = failedToLoad
    ? 'Snippet could not be loaded'
    : 'Snippet not found'
  return (
    <>
      <div className="flex items-center justify-between gap-2">
        <span
          role="status"
          className="flex items-center gap-1 text-sm font-medium text-destructive">
          <SquareCode aria-hidden="true" className="size-4" />
          {label}
        </span>
        {failedToLoad && onRetry && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="shrink-0"
            onClick={onRetry}>
            Try again
          </Button>
        )}
        {interactive && !failedToLoad && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            data-remove-snippet=""
            className="text-destructive hover:bg-destructive/10"
            onClick={onRemove}>
            Remove
          </Button>
        )}
      </div>
      {!failedToLoad && (
        <p className="mt-2 text-xs text-muted-foreground">
          Calls with this script fail until you remove it. If Careforce created
          it, ask Careforce to share it again.
        </p>
      )}
      <p className="mt-3 font-mono text-xs break-all text-muted-foreground">
        {id}
      </p>
    </>
  )
}
